import { Controller } from '@hotwired/stimulus';
import { application } from 'src';


application.register('select-after-confirm', class extends Controller {
  static values = { question: String };
  static targets = ['field'];

  connect () {
    this.currentSelection = this.#getCurrentSelection();
    this.fieldTarget.addEventListener('change', this.#processChange.bind(this));
  }

  disconnect() {
    this.fieldTarget.removeEventListener('change', this.#processChange.bind(this));
  }

  #processChange(event) {
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (confirm(this.questionValue)) {
      this.#updateCurrentSelection();
      this.#dispatchConfirmedSelection();
    } else {
      this.#revertSelection();
    };
  }

  #getCurrentSelection() {
    return this.fieldTarget.options[this.fieldTarget.selectedIndex].value;
  }
  
  #updateCurrentSelection() {
    this.currentSelection = this.#getCurrentSelection();
  }

  #dispatchConfirmedSelection() {
    this.fieldTarget.dispatchEvent(new CustomEvent('confirmedSelection'));
  }

  #revertSelection() {
    this.#getOption(this.currentSelection).selected = true;
  }

  #getOption(selection) {
    return Array.from(this.fieldTarget.options).find(option => option.value === selection);
  }
});
